// extracted by mini-css-extract-plugin
export default {"cls1":"Rating-cls1__nO","cls2":"Rating-cls2_gTW Rating-cls1__nO"};